import { createContext } from "preact";

export type SearchType = {
  searchString: string;
  setSearchString: (str: string) => void;
};

const SearchContext = createContext<SearchType>({
  searchString: "",
  setSearchString: () => {},
});
export default SearchContext;
